import { createFileRoute } from "@tanstack/react-router";
import BranchenPage from "@/pages/BranchenPage";
import { buildRouteHead } from "@/lib/route-head";

export const Route = createFileRoute("/branchen/")({
  head: () =>
    buildRouteHead({
      title: "Branchen | Webdesign für Ärzte, Hotels & Handwerker",
      description:
        "Spezialisierte Webseiten für Ihre Branche: Ärzte, Hotels, Steuerberater, Handwerker und mehr. Agentur aus Wernigerode im Harz.",
      path: "/branchen",
      image: "/images/industries/hotel-1024.webp",
      imageAlt: "Branchenlösungen für Hotels und Dienstleister",
      imageWidth: 1024,
      imageHeight: 697,
    }),
  component: BranchenPage,
});
